function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.to-array.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from 'features/fabric';
import { default as StandardImageRenderer } from 'features/richText/components/richTextMarkdown/ImageComponent';
import RichTextMarkdown from 'features/richText/components/richTextMarkdown/RichTextMarkdown';
import { Children, Fragment, useMemo } from 'react';
import ImageTextList from './imageTextList/ImageTextList';
function renderContent(contents) {
    if (!contents || (contents === null || contents === void 0 ? void 0 : contents.length) === 0) {
        return null;
    }
    return contents.map((content)=>{
        switch(true){
            // @ts-expect-error - Unclear types for content
            case (content === null || content === void 0 ? void 0 : content.type) === 'imageTextList':
                {
                    // @ts-expect-error - Unclear types for content
                    const textListContent = content;
                    return /*#__PURE__*/ _jsx(ImageTextList, {
                        heading: textListContent === null || textListContent === void 0 ? void 0 : textListContent.title,
                        list: textListContent === null || textListContent === void 0 ? void 0 : textListContent.list,
                        text: textListContent === null || textListContent === void 0 ? void 0 : textListContent.body
                    }, textListContent === null || textListContent === void 0 ? void 0 : textListContent.slug);
                }
            // @ts-expect-error - Unclear types for content
            case Boolean(content === null || content === void 0 ? void 0 : content.body):
                return /*#__PURE__*/ _jsx(Fragment, {
                    children: // @ts-expect-error - Unclear types for content
                    /*#__PURE__*/ _jsx(RichTextMarkdown, {
                        children: content === null || content === void 0 ? void 0 : content.body
                    })
                }, content === null || content === void 0 ? void 0 : content.slug);
            default:
                return null;
        }
    });
}
function flatten(text, child) {
    var _child_props;
    return typeof child === 'string' ? text + child : Children.toArray(child === null || child === void 0 ? void 0 : (_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.children).reduce(flatten, text);
}
const HeadingRenderer = (_0)=>{
    let { level } = _0, props = _object_without_properties(_0, [
        "level"
    ]);
    const children = Children.toArray(props.children);
    const text = children.reduce(flatten, '');
    const slug = text.toLowerCase().replace(/\W/g, '-');
    const Tag = `h${level}`;
    return /*#__PURE__*/ _jsx(Tag, {
        id: slug,
        children: props.children
    });
};
const Content = ({ article })=>{
    const contents = article === null || article === void 0 ? void 0 : article.contents;
    let content = (article === null || article === void 0 ? void 0 : article.body) || '';
    if (article === null || article === void 0 ? void 0 : article.title) {
        content = `# ${article === null || article === void 0 ? void 0 : article.title}\n${content}`;
    }
    const components = useMemo(()=>{
        const headings = {};
        for(let i = 1; i <= 6; i++){
            // @ts-expect-error - Unclear types for headings
            headings[`h${i}`] = (props)=>// @ts-expect-error - Unclear types for HeadingRenderer
                /*#__PURE__*/ _jsx(HeadingRenderer, _object_spread({
                    level: i
                }, props));
        }
        // eslint-disable-next-line @eslint-react/no-nested-component-definitions
        const ImageRenderer = (props)=>{
            // @ts-expect-error - Unclear types for props
            return /*#__PURE__*/ _jsx(StandardImageRenderer, _object_spread_props(_object_spread({}, props), {
                lazyLoad: false
            }));
        };
        return _object_spread_props(_object_spread({}, headings), {
            img: ImageRenderer
        });
    }, []);
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                paddingBottom: "l",
                children: /*#__PURE__*/ _jsx(RichTextMarkdown, {
                    components: components,
                    children: content
                })
            }),
            contents && renderContent(contents)
        ]
    });
};
export default Content;
